<template>
  <div class="flex items-center">
    <span
      v-for="star in 5"
      :key="star"
      @click="setRating(star)"
      @mouseover="hoverRating(star)"
      @mouseleave="resetHover"
      class="cursor-pointer text-2xl"
      :class="{
        'text-yellow-500': star <= currentRating || star <= hover,
        'text-gray-400': star > currentRating && star > hover
      }"
    >
      ★
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentRating: this.value,
      hover: 0
    };
  },
  methods: {
    setRating(star) {
      if (this.disabled) {
        return;
      }
      this.currentRating = star;
      this.$emit("input", star);
    },
    hoverRating(star) {
      if (this.disabled) {
        return;
      }
      this.hover = star;
    },
    resetHover() {
      this.hover = 0;
    }
  }
};
</script>

<style scoped>
.star {
  transition: color 0.2s;
}
</style>
